import { render, staticRenderFns } from "./FleetGroup.vue?vue&type=template&id=048deddc&"
import script from "./FleetGroup.vue?vue&type=script&lang=js&"
export * from "./FleetGroup.vue?vue&type=script&lang=js&"
import style0 from "./FleetGroup.vue?vue&type=style&index=0&id=048deddc&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports